var React = require('react');

function FbInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.9062 0.40625H1.09375C0.713477 0.40625 0.40625 0.713477 0.40625 1.09375V16.9062C0.40625 17.2865 0.713477 17.5938 1.09375 17.5938H16.9062C17.2865 17.5938 17.5938 17.2865 17.5938 16.9062V1.09375C17.5938 0.713477 17.2865 0.40625 16.9062 0.40625ZM14.9211 5.42285H13.5482C12.4719 5.42285 12.2635 5.93418 12.2635 6.68613V8.34258H14.833L14.4979 10.9357H12.2635V17.5938H9.58438V10.9379H7.34355V8.34258H9.58438V6.43047C9.58438 4.21113 10.94 3.00156 12.9209 3.00156C13.8705 3.00156 14.6848 3.07246 14.9232 3.10469V5.42285H14.9211Z","fill":"#F9F9F9"}));
}

FbInline.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = FbInline;

FbInline.default = FbInline;
